import { extractArrayFromQuery } from '@/utils/user/getSearchParamsFromQuery';

export const educatorFilterFields = {
  name: 'name',
  organization: 'organization',
  district: 'district',
  searchEducator: 'searchEducator',

  grades: 'grades',
  subjects: 'subjects',
  practices: 'practices',

  joined: 'joined',

  completed: 'completed',
  completedOperator: 'completedOperator',
  created: 'created',
  createdOperator: 'createdOperator',
};

// Operator params that always accompany a value param — excluded from filter badge count.
export const educatorFilterCountExclusions = ['createdOperator', 'completedOperator'];

export function getEducatorFilter(search, network) {
  const filter = {
    intent: 'educator',
    completed: search.completed?.length ? { value: search.completed, operator: search.completedOperator } : undefined,
    created: search.created?.length ? { value: search.created, operator: search.createdOperator } : undefined,
    joined: search.joined?.length ? search.joined : undefined,
    practices: search.practices?.length ? extractArrayFromQuery(search, 'practices') : undefined,
    subjects: search.subjects?.length ? extractArrayFromQuery(search, 'subjects') : undefined,
    grades: search.grades?.length ? extractArrayFromQuery(search, 'grades') : undefined,
    networkId: network?.id,
    profile: search.searchEducator?.length ? search.searchEducator : undefined,
    name: search.name?.length ? search.name : undefined,
    school: search.organization?.length ? search.organization : undefined,
    district: search.district?.length ? search.district : undefined,
  };
  return { filter };
}
